




















import TimeRangeControls from "@/components/TimeRangeControls.vue";
import { COMPOUND_STATS_LIFETIME } from "@/config/series";
import { Series } from "@/types/common";
import { Component, Vue } from "vue-property-decorator";
import { Getter } from "vuex-class";

@Component({ components: { TimeRangeControls } })
export default class CompoundStatsView extends Vue {
  created() {
    this.$store.dispatch("debugMode/fetchCompoundStatsByTimeRange");

    // Refetch data periodically
    this.intervalID = setInterval(() => {
      this.$store.dispatch("debugMode/fetchCompoundStatsByTimeRange");
    }, COMPOUND_STATS_LIFETIME);
  }

  beforeDestroy() {
    // Refetch data clean up
    clearInterval(this.intervalID);
  }

  @Getter("debugMode/compoundStatsSeries") series!: (chartID: string) => false | Series;

  intervalID = 0;
}
